import { useAuth } from '../../contexts/AuthContext';
import { LmsDataProvider } from '../../contexts/LmsDataContext';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import DashboardHeader from './DashboardHeader';
import MobileBottomNav from './MobileBottomNav';
const AppLayout = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();
  const isStudent = currentUser?.role === 'student';

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-stone-200 border-t-[#d61f74]" />
      </div>
    );
  }

  // Redirect if not authenticated
  if (!currentUser) {
    navigate('/login');
    return null;
  }

  return (
    <LmsDataProvider>
      <div className="flex h-screen bg-[#f4f2ef]">
        {/* Mobile overlay is rendered inside Sidebar (single source, avoids double-scrim). */}
        <Sidebar />

        {/* Main Content */}
        <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
          <DashboardHeader />
          <main
            className={`flex-1 overflow-x-hidden overflow-y-auto px-3 py-4 pb-24 sm:px-6 sm:py-5 md:pb-5 lg:px-8 lg:py-6 ${
              isStudent ? 'bg-[#f6f4f1]' : 'bg-[#f4f2ef]'
            }`}
          >
            {children}
          </main>
          <MobileBottomNav />
        </div>
      </div>
    </LmsDataProvider>
  );
};

export default AppLayout;
